import { find, map } from 'lodash';

import { requestStatuses, responseStatuses } from '../../constants';
import { translate } from 'helpers/translateHelper';
import moment from 'moment';
import { getUTCDateString } from 'helpers/dateHelper';
import { getInitialEndDate, getYesterdayEndDate } from 'sharedComponents/TimeSelectorRow/helpers';

// TODO: Commented due to Load measurement and collect Raw data V2 update
export const getSensorFeature = (sensorFeatures, sensorFeature) => {
    return find(sensorFeatures, (s) => {
        return s.featureKeyName === sensorFeature;
    });
};

// eslint-disable-next-line import/no-unused-modules
export const getRequestStatusText = (featureValue) => {
    switch (featureValue) {
        case requestStatuses.COMPLETED:
            return translate('ABB.Powertrain.Frontend.requestStatusCompletedText');
        case requestStatuses.ERROR:
            return translate('ABB.Powertrain.Frontend.requestStatusErrorText');
        case requestStatuses.PENDING:
            return translate('ABB.Powertrain.Frontend.requestStatusPendingText');
        case requestStatuses.NOT_REQUESTED_INITIAL:
        case requestStatuses.NOT_REQUESTED:
        default:
            return translate('ABB.Powertrain.Frontend.requestStatusNotRequestedText');
    }
};

// eslint-disable-next-line import/no-unused-modules
export const getResponseStatusText = (featureValue) => {
    switch (featureValue) {
        case responseStatuses.COMPLETED_SUCCESSFULLY:
            return translate('ABB.Powertrain.Frontend.responseStatusCompletedSuccessfullyText');
        case responseStatuses.COULD_NOT_CONNECT_TO_THE_SENSOR:
            return translate('ABB.Powertrain.Frontend.responseStatusCouldNotConnectText');
        case responseStatuses.INTERNAL_ERROR:
            return translate('ABB.Powertrain.Frontend.responseStatusInternalErrorText');
        case responseStatuses.NO_MEASUREMENT_AVAILABLE:
            return translate('ABB.Powertrain.Frontend.responseStatusNoMeasurementAvailableText');
        case responseStatuses.SENSOR_NOT_FOUND:
            return translate('ABB.Powertrain.Frontend.responseStatusSensorNotFoundText');
        case responseStatuses.WRONG_PASSKEY:
            return translate('ABB.Powertrain.Frontend.responseStatusWrongPasskeyText');
        case responseStatuses.INVALID_PARAMETERS:
            return translate('ABB.Powertrain.Frontend.responseStatusInvalidRequestParametersText');
        case responseStatuses.DEGRADED_MODE:
            return translate('ABB.Powertrain.Frontend.responseStatusDegradedModeText');
        default: return null;
    }
};

// eslint-disable-next-line import/no-unused-modules
export const isRequestStatusRequested = requestStatus => {
    return requestStatus !== requestStatuses.NOT_REQUESTED && requestStatus !== requestStatuses.NOT_REQUESTED_INITIAL;
};

export const formatMultiToggleOptions = (options) => {
    return map(options, (option) => {
        return {
            ...option,
            label: translate(option.label)
        };
    });
};

// Helper function to check if date is today
const isToday = (date) => {
    return new Date(date).toDateString() === new Date().toDateString();
};

// Helper function to check if date is yesterday
const isYesterday = (date) => {
    return moment(date).isSame(moment().subtract(1, 'day'), 'day');
};

// Helper function to handle V2 tab date adjustment
export const adjustDatesForV2Tabs = (from, to) => {
    if (!isToday(to)) {
        return { from, to };
    }

    const dayDifference = moment(to).diff(moment(from), 'day');
    const startDate = moment(dayDifference === 1 ? to : from).subtract(1, 'days').startOf('day').toDate();

    return {
        from: getUTCDateString(startDate),
        to: getYesterdayEndDate()
    };
};

// Helper function to handle regular tabs date adjustment
export const adjustDatesForRegularTabs = (from, to) => {
    if (!isYesterday(to)) {
        return { from, to };
    }

    const hoursDifference = moment(to).diff(moment(from), 'hours');

    if (hoursDifference < 24) {
        const toDate = moment().toDate();
        const startDate = moment(toDate).subtract(1, 'days').toDate();
        return {
            from: getUTCDateString(startDate),
            to: getUTCDateString(toDate)
        };
    }

    const startDate = moment(from).add(1, 'day').startOf('day').toDate();
    return {
        from: getUTCDateString(startDate),
        to: getInitialEndDate()
    };
};
